module.exports = __webpack_public_path__ + "static/media/logo.3f431b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Menu/logo.png
// module id = 246
// module chunks = 0